import React from 'react'
import styles from './GreyBoxMessage.scss'
import { Icon } from 'components'

const GreyBoxMessage = (props) => {
	let styleName = "a_greyboxmessage__success"
	if(props.type === "error") {
		styleName = "a_greyboxmessage__error"
	}

	let classNames = styles.a_greyboxmessage;
	if(props.position === 'inside'){
		classNames = classNames + ' ' + styles.isInside
	}

  	return (
		<div className={styles[styleName] + ' ' + classNames}>
            <div className={styles["a_greyboxmessage__icon"]}><Icon type="image" content={props.type} width="25px" /></div>
            <div className={styles["a_greyboxmessage__text"]}>{props.children}</div>
		</div>
	)
}
export default GreyBoxMessage



// WEBPACK FOOTER //
// ./src/components/atoms/GreyBoxMessage/index.js